import Immutable from 'immutable';
import { List } from 'immutable';
import {handleActions} from 'redux-actions';

const defaultState = Immutable.fromJS({
  isLoading: false,

  userId: 1, // TODO
  accounts: List(),
  tags: List(),
  tagsAmount: 0,
  accountTotal: 0,
  selectedAccount: { accountId: 0, isScrollTo: false },

  officeData: null,

  applications: List(),

  supportTypes: List(),

  transactions: List(),
  report: {
    transactions: List()
  }
})

function update(state, name, payload) {
  let data = {}
  data[name] = state.toJS()[name]
  var index = data[name].findIndex(item => String(item.id) === String(payload.id))
  data[name][index] = Object.assign({}, data[name][index], payload)
  return state.merge(data)
}

function insert(state, name, payload) {
  let data = {}
  data[name] = state.toJS()[name]
  data[name].push(payload)

  return state.merge(data)
}

function remove(state, name, payload) {
  let data = {}
  data[name] = state.toJS()[name]
  data[name] = data[name].filter(item => item.id !== payload.id)

  return state.merge(data)
}

export default handleActions({
  LOADING: (state, action) => {
    return state.merge({isLoading: action.payload})
  },
  GET_USER: (state, action) => {
    return state.merge(action.payload)
  },
  ACCOUNT_LIST: (state, action) => {
    const accounts = action.payload && action.payload.accounts
    return state.merge({accounts: accounts})
  },
  ACCOUNT_TOTAL: (state, action) => {
    const total = action.payload && action.payload.total
    return state.merge({accountTotal: total})
  },
  ACCOUNT_SHOW: (state, action) => {
    return  update(state, 'accounts', action.payload)
  },
  ACCOUNT_CREATE: (state, action) => {
    return insert(state, 'accounts', action.payload)
  },
  ACCOUNT_DELETE: (state, action) => {
    return remove(state, 'accounts', action.payload)
  },
  ACCOUNT_SUSPEND: (state, action) => {
    return update(state, 'accounts', action.payload)
  },
  ACCOUNT_RESUME_SUSPEND: (state, action) => {
    return update(state, 'accounts', {id: action.payload.id, is_suspended: false})
  },
  ACCOUNT_AGGREGATE: (state, action) => {
    return state
  },
  SUB_ACCOUNT_LIST: (state, action) => {
    return update(state, 'accounts', action.payload)
  },
  ACCOUNT_UPDATE: (state, action) => {
    return  update(state, 'accounts', action.payload)
  },
  ACCOUNT_INQURE: (state, action) => {
    return  update(state, 'accounts', action.payload)
  },
  ACCOUNT_ANSWER: (state, action) => {
    return  update(state, 'accounts', action.payload)
  },
  SUB_ACCOUNT_UPDATE: (state, action) => {
    const payload = action.payload
    const subAccount = action.payload.sub_accounts[0]
    let accounts = state.toJS()['accounts']
    var index = accounts.findIndex(item => item.id === payload.id)
    var indexSub = accounts[index]['sub_accounts']['sub_accounts'].findIndex(item => item.id === subAccount.id)
    accounts[index]['sub_accounts']['sub_accounts'][indexSub] = Object.assign(
      {},
      accounts[index]['sub_accounts']['sub_accounts'][indexSub],
      subAccount
    )

    return state.merge({accounts: accounts})
  },
  ACCOUNT_SELECT: (state, action) => {
    return state.merge({selectedAccount: action.payload})
  },
  // support email
  SUPPORT_EMAIL_CREATE: (state, action) => {
    return state;
  },
  SUPPORT_EMAIL_TYPES: (state, action) => {
    return state.merge({supportTypes: action.payload})
  },
  // office
  OFFICE_LIST: (state, action) => {
    return state.merge({officeData: action.payload})
  },
  OFFICE_CREATE: (state, action) => {
    return state.merge({officeData: action.payload})
  },
  OFFICE_UPDATE: (state, action) => {
    return state.merge({officeData: action.payload})
  },
  // tag
  TAG_LIST: (state, action) => {
    return state.merge({tags: action.payload})
  },
  TAG_CREATE: (state, action) => {
    return insert(state, 'tags', action.payload)
  },
  TAG_UPDATE: (state, action) => {
    return update(state, 'tags', action.payload)
  },
  TAG_DELETE: (state, action) => {
    return remove(state, 'tags', action.payload)
  },
  TAG_AMOUNT: (state, action) => {
    return state.merge({tagsAmount: action.payload})
  },
  // application
  APPLICATION_LIST: (state, action) => {
    return state.merge({applications: action.payload})
  },
  APPLICATION_DELETE: (state, action) => {
    return state;
  },
  // CSV
  TRANSACTION_LIST: (state, action) => {
    return state.merge({transactions: action.payload})
  },
  REPORT_TRANSACTIONS: (state, action) => {
    return state.merge({report: {transactions: action.payload}})
  },
  APP_AUTHORIZED_LOG_CREATE: (state, action) => {
    return state;
  },
}, defaultState)
